import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import Link from "flarum/common/components/Link";
import IndexPage from "flarum/forum/components/IndexPage";
import PageStructure from "flarum/forum/components/PageStructure";
function pages() {
  const data = app.data.xgayFeaturedPages;
  if (!Array.isArray(data)) return [];
  return data.filter(entry => {
    if (typeof entry !== "object" || entry === null) return false;
    const page = entry;
    return Number.isInteger(page.id) && Number(page.id) > 0 && typeof page.title === "string" && typeof page.slug === "string";
  });
}
function block(placement) {
  const featured = pages();
  if (!featured.length) return null;
  return m("section", {
    className: "FeaturedPages FeaturedPages--" + placement
  }, m("h3", null, app.translator.trans("xgay-pages-seo-improve.forum.featured")), m("ul", null, featured.map(page => m("li", {
    key: page.id
  }, m(Link, {
    href: app.route("page", {
      id: page.id + "-" + page.slug
    })
  }, page.title)))));
}
app.initializers.add("xgay-pages-seo-improve", () => {
  extend(PageStructure.prototype, "sidebarItems", function (items) {
    if (app.current.matches(IndexPage)) items.add("xgay-featured-pages", block("desktop"), -90);
  });
  extend(IndexPage.prototype, "contentItems", function (items) {
    items.add("xgay-featured-pages", block("mobile"), items.getPriority("discussionList") - 0.5);
  });
});